@switch (type()) {
  @case ('vcard') {
    <button
      id="downloadButtonNormal"
      (click)="downloadVCard()"
      class="mobi-file-download flex justify-between mobi-ui-width-full py-[12px] px-3"
    >
      <div class="flex items-center">
        <mobi-ui-icon-major
          name="business_card"
          class="mobi-ui-text-inked mobi-ui-margin-r-xxs"
        />
        <span class="text-black">
          {{
            'vcard_save_contact'
              | texts
                : {
                    context: 'frontend',
                    default: 'Kontakt speichern',
                  }
          }}
        </span>
      </div>
      <mobi-ui-icon-major name="download" class="arrow mobi-ui-ink-grey" />
    </button>
  }
  @case ('image') {
    <div>
      @if (file()?.image && file()?.image?.entity) {
        <a
          [href]="downloadImage(file()!)"
          target="_blank"
          data-track-download
          class="mobi-file-download flex justify-between mobi-ui-width-full px-3"
        >
          <div class="flex items-center">
            <mobi-ui-icon-major
              name="business_card"
              class="mobi-ui-text-inked mobi-ui-margin-r-xxs"
            />
            <span class="text-black">
              {{
                'photo_save'
                  | texts
                    : {
                        context: 'frontend',
                        default: 'Photo Download',
                      }
              }}
            </span>
          </div>
          <mobi-ui-icon-major name="download" class="arrow mobi-ui-ink-grey" />
        </a>
      }
    </div>
  }
}
